import React from 'react';
import 'style-loader!css-loader?modules!less-loader!autoprefixer-loader?{browsers:["last 2 version","Firefox 15"]}!./index.less';

export default class Clock extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      date: 0 ,
    };
  }
  componentDidMount(){
    this.timerID = setInterval(()=>this.setState({ date : new Date().getTime() - this.props.date}),1000)
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  render() {
    return (
      <div>
        <h1>Hello, world!</h1>
        <h2>It is {String(this.state.date).slice(0,-3)|| 0}.</h2>
      </div>
    )
  }
};
